import { useState, useEffect } from 'react'
import styled from 'styled-components'

const Column = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin: 5em 0;
    @media (max-width:1050px){
        display: flex;
        flex-direction: column;
        img{
            margin: 2em auto;
            width: 50%;
        }
    }
`
const IFrame = styled.iframe`
    width: 600px;
    height: 450px;
    border: 0;
    box-shadow: 0px 4px 4px rgba(189, 189, 189, 0.25);
    border-radius: 8px;
    margin: 1em 0;
    @media (max-width:600px){
        max-width: 100%;
        width: 600px;
        height: 450px;
        margin: 0;
    }
`
const List = styled.ul`
    list-style: none;
    li{
        cursor: pointer;
        position: relative;
        max-width:650px;
        margin:1em 2em;
        margin-bottom:3em;
        &::before{
            content: '';
            position: absolute;
            width: 27px;
            height: 27px;
            left: -50px;
            top: 30%;
            border-radius: 50%;
            background: var(--bg-quad);
        }
        &.highlighted{
            &::before{
                background: var(--bg-primary);
            }
        }
        p{
            padding-left: 1em;
            font-size: 24px;
            line-height: 36px;
        }
        p.title{
            font-weight: 500;
        }
        p.address{
            font-weight: normal;
        }
    }
    @media (max-width:600px){
        width: 90%;
        margin: 0 auto;
        li{
            margin:2em 1em;
            margin-left:2em;
            &::before{ left:-30px; }
            p{ font-size: 18px; }
        }
    }
`
function MapLocation () {
  const [country, setCountry] = useState('')
  const [url, setUrl] = useState('')
  const sessionLanguage = typeof window !== 'undefined' && sessionStorage.getItem('lang')

  const getLocation = () => {
    if (sessionLanguage === 'id') {
      return (
        [
          // {
          //   country: 'Indonesia',
          //   address: 'Jl. Kemang Utara VII A No.45 HJ, Bangka Kec. Mampang Prpt. Kota Jakarta Selatan Daerah Khusus Ibukota Jakarta 12730',
          //   url: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15864.227279124114!2d106.8228202!3d-6.2562454!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xc0a4caa43d6ad47f!2sPT%20SELLON%20TECH%20INDONESIA!5e0!3m2!1sen!2sid!4v1649318162164!5m2!1sen!2sid'
          // },
          {
            country:`Indonesia`,
            address: `AXA TOWER, LT. 45 JL. PROF DR SATRIO NO. 18, Kel. Karet Kuningan, Kec. Setiabudi, Kota Adm. Jakarta Selatan, Provinsi DKI Jakarta, Kode Pos: 12940`,
            url:`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.2957949695683!2d106.82677948582148!3d-6.224674470889559!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f3fa6213e04b%3A0x74ff6c020a12d857!2sAXA%20TOWER!5e0!3m2!1sid!2sid!4v1636530764668!5m2!1sid!2sid`
          },
          {
            country: 'Singapore',
            // address: '62 Ubi Road 1 # 09-05, Oxley BizHub 2, Singapore 408734',
            // url: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.740127304574!2d103.88947685095533!3d1.3320456619971461!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da17f339aaaaab%3A0x649d901ef51bc2a7!2sOxley%20BizHub%202!5e0!3m2!1sen!2sid!4v1624952680083!5m2!1sen!2sid'
            // address: '1 North Bridge Rd, #07 04 High Street Centre, Singapore 179094', //old
            address: '1 North Bridge Rd, Singapore 179094',
            // url: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d10051.1603051673!2d103.84889477728385!3d1.2909249570093733!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da19a0958fa7c5%3A0x17bfb9238ff98991!2s1%20North%20Bridge%20Rd%2C%20%2307%2004%20High%20Street%20Centre%2C%20Singapore%20179094!5e0!3m2!1sen!2sid!4v1664771421904!5m2!1sen!2sid' //old
            url: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d997.2018841997237!2d103.84869846959046!3d1.2897315406838903!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da19a0bb970cdf%3A0x863168fc4b0e2b8d!2s1%20North%20Bridge%20Rd%2C%20Singapore%20179094!5e0!3m2!1sen!2sid!4v1714717630277!5m2!1sen!2sid'
          }
        ]
      )
    }
    return (
      [
        {
          country: 'Singapore',
          // address: '62 Ubi Road 1 # 09-05, Oxley BizHub 2, Singapore 408734',
          // url: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.740127304574!2d103.88947685095533!3d1.3320456619971461!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da17f339aaaaab%3A0x649d901ef51bc2a7!2sOxley%20BizHub%202!5e0!3m2!1sen!2sid!4v1624952680083!5m2!1sen!2sid'
          // address: '1 North Bridge Rd, #07 04 High Street Centre, Singapore 179094', //old
          address: '1 North Bridge Rd, Singapore 179094',
          // url: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d10051.1603051673!2d103.84889477728385!3d1.2909249570093733!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da19a0958fa7c5%3A0x17bfb9238ff98991!2s1%20North%20Bridge%20Rd%2C%20%2307%2004%20High%20Street%20Centre%2C%20Singapore%20179094!5e0!3m2!1sen!2sid!4v1664771421904!5m2!1sen!2sid' //old
          url: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d997.2018841997237!2d103.84869846959046!3d1.2897315406838903!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da19a0bb970cdf%3A0x863168fc4b0e2b8d!2s1%20North%20Bridge%20Rd%2C%20Singapore%20179094!5e0!3m2!1sen!2sid!4v1714717630277!5m2!1sen!2sid'
        },
        // {
        //   country: 'Indonesia',
        //   address: 'Jl. Kemang Utara VII A No.45 HJ, Bangka Kec. Mampang Prpt. Kota Jakarta Selatan Daerah Khusus Ibukota Jakarta 12730',
        //   url: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15864.227279124114!2d106.8228202!3d-6.2562454!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xc0a4caa43d6ad47f!2sPT%20SELLON%20TECH%20INDONESIA!5e0!3m2!1sen!2sid!4v1649318162164!5m2!1sen!2sid'
        // }
        {
          country:`Indonesia`,
          address: `AXA TOWER, LT. 45 JL. PROF DR SATRIO NO. 18, Kel. Karet Kuningan, Kec. Setiabudi, Kota Adm. Jakarta Selatan, Provinsi DKI Jakarta, Kode Pos: 12940`,
          url:`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.2957949695683!2d106.82677948582148!3d-6.224674470889559!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f3fa6213e04b%3A0x74ff6c020a12d857!2sAXA%20TOWER!5e0!3m2!1sid!2sid!4v1636530764668!5m2!1sid!2sid`
        }
      ]
    )
  }

  useEffect(() => {
    if (sessionLanguage === 'id') {
      setCountry('Indonesia')
      // setUrl('https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15864.227279124114!2d106.8228202!3d-6.2562454!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xc0a4caa43d6ad47f!2sPT%20SELLON%20TECH%20INDONESIA!5e0!3m2!1sen!2sid!4v1649318162164!5m2!1sen!2sid')
      setUrl(`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.2957949695683!2d106.82677948582148!3d-6.224674470889559!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f3fa6213e04b%3A0x74ff6c020a12d857!2sAXA%20TOWER!5e0!3m2!1sid!2sid!4v1636530764668!5m2!1sid!2sid`);
    } else {
      setCountry('Singapore')
      // setUrl('https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.740127304574!2d103.88947685095533!3d1.3320456619971461!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da17f339aaaaab%3A0x649d901ef51bc2a7!2sOxley%20BizHub%202!5e0!3m2!1sen!2sid!4v1624952680083!5m2!1sen!2sid')
      // setUrl('https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d10051.1603051673!2d103.84889477728385!3d1.2909249570093733!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da19a0958fa7c5%3A0x17bfb9238ff98991!2s1%20North%20Bridge%20Rd%2C%20%2307%2004%20High%20Street%20Centre%2C%20Singapore%20179094!5e0!3m2!1sen!2sid!4v1664771421904!5m2!1sen!2sid') //old
      setUrl('https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d997.2018841997237!2d103.84869846959046!3d1.2897315406838903!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da19a0bb970cdf%3A0x863168fc4b0e2b8d!2s1%20North%20Bridge%20Rd%2C%20Singapore%20179094!5e0!3m2!1sen!2sid!4v1714717630277!5m2!1sen!2sid')
    }
  }, [])
  return (
        <Column>
            <List>
                {getLocation().map((location, key) =>
                    <li
                        key={key}
                        className={country === location.country ? 'highlighted' : ''}
                        onClick={() => { setUrl(location.url); setCountry(location.country) }}
                    >
                        <p className="title">{location.country}</p>
                        <p className="address">{location.address}</p>
                    </li>
                )}
            </List>
            <IFrame src={url} allowfullscreen="" loading="lazy" />
        </Column>
  )
}

export default MapLocation
